import React from 'react';
import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

import { BELOW_COST_DM_APPROVAL_WARNING } from '../../helpers/calculateMargin';

function BelowCostApprovalAlert() {
    return (
        <Alert
            icon={<IconAlertTriangle size={16} />}
            color="orange"
            variant="light"
        >
            {BELOW_COST_DM_APPROVAL_WARNING}
        </Alert>
    );
}

export default BelowCostApprovalAlert;
